import { apiFetch } from "./api";

export interface ClientContactDto {
  id: number;
  clientId: number;
  firstName: string;
  lastName: string | null;
  email: string | null;
  phone: string | null;
  mobile: string | null;
  isPrimary: boolean;
  deleted: boolean;
}

export interface CreateClientContactRequest {
  firstName: string;
  lastName?: string | null;
  email?: string | null;
  phone?: string | null;
  mobile?: string | null;
  isPrimary?: boolean | null;
}

export const clientContactsApi = {
  list: (clientId: number): Promise<ClientContactDto[]> =>
    apiFetch<ClientContactDto[]>(`/api/clients/${clientId}/contacts`),

  create: (clientId: number, body: CreateClientContactRequest): Promise<ClientContactDto> =>
    apiFetch<ClientContactDto>(`/api/clients/${clientId}/contacts`, {
      method: "POST",
      body: JSON.stringify(body),
    }),
};
